import { Injectable } from '@angular/core';
import { ReportLaunchServiceBase } from './report-launch.service.base';
import { ReportViewerPayload } from './report-payload.protocol';

export type { ReportViewerPayload } from './report-payload.protocol';

@Injectable({ providedIn: 'root' })
export class ReportViewerLaunchService extends ReportLaunchServiceBase {
  open(payload: ReportViewerPayload): boolean {
    return this.openReportWindow('viewer', 'report-viewer', payload);
  }
}
